import { useEffect, useState } from "react";
import { Moon, Sun } from "lucide-react";

export const ThemeToggle = ({ className = "" }) => {
  const [dark, setDark] = useState(() => localStorage.getItem("pc-theme") === "dark");
  useEffect(() => {
    document.documentElement.classList.toggle("dark", dark);
    localStorage.setItem("pc-theme", dark ? "dark" : "light");
  }, [dark]);
  return (
    <button
      data-testid="theme-toggle"
      aria-label="Toggle theme"
      onClick={() => setDark(!dark)}
      className={`h-9 w-9 inline-flex items-center justify-center rounded-full border border-slate-200 dark:border-slate-800 hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors ${className}`}
    >
      {dark ? <Sun size={16} /> : <Moon size={16} />}
    </button>
  );
};
